export const sfAccountDataQueryKeys = {
    all: (accountId: string) => ['sf-account-data', accountId] as const,
};
